<template>
<loader v-bind="{ loading }">
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'software-manager', params: { software: $route.params.software }}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'software-distributions', params: { software: $route.params.software }}">
        <a>Distributions</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'software-versions', params: { software: $route.params.software }}">
        <a>Versions</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'software-vulnerabilities', params: { software: $route.params.software }}">
        <a>Vulnerabilities</a>
      </router-link>
      <router-link exact tag="li" :to="{ name: 'software-edit', params: { software: $route.params.software }}">
        <a>Edit</a>
      </router-link>
    </ul>
  </div>
  <router-view />  
</loader>  
</template>
<script>
export default {
  
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    Promise.all([
      this.$store.dispatch('software/loadSoftware', this.$route.params.software),
    ]).then(() => {
      this.loading = false
    })
  },
}
</script>